module.exports = __webpack_public_path__ + "e6.no2.4d1553df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e6.no2.jpg
// module id = RlX4
// module chunks = 0